<template>
	<div class="app" style="width: 100%;">
		<div class="bg1" style="width:100%;height: 180px;">
			<el-row type="flex" justify="center">
				<el-col :span="22">
					<div style="margin:0 auto;color:#949494;position: relative;" class="font">
							<div class="flex" style="padding:30px 0;">
								<div style="font-size:16px;color:#000000">{{rowInfor.name}}</div>
								<div
									style="margin: 0 30px; border:1px solid #42B983;background: #c0ffe7;border-radius: 2px;padding:3px;">
									{{rowInfor.follow_num}}人关注
								</div>
								<div style="border:1px solid #42B983;background: #c0ffe7;border-radius: 2px;padding:3px;">
									{{rowInfor.collect_num}}人收藏
								</div>
							</div>
							<div class="flex">
								<div style="margin-right: 30px;">最新双选会：<span v-if="rowInfor.last_meeting">{{rowInfor.last_meeting.begin_date == rowInfor.last_meeting.end_date ? timeFilter(rowInfor.last_meeting.begin_date) : `${timeFilter(rowInfor.last_meeting.begin_date)} - ${timeFilter(rowInfor.last_meeting.end_date,true)}`}}</span></div>
								<div>地点：{{rowInfor.address}}</div>
							</div>
							<div class="flex" style="margin: 10px 0;">
								<div style="margin-right: 30px;">形式：<span v-if="rowInfor.last_meeting">{{rowInfor.last_meeting.meeting_type}}</span></div>
								<div style="margin-right: 30px;">学历：{{rowInfor.education}}</div>
								<div style="margin-right: 30px;">类型：{{rowInfor.university_type}}</div>
								<div style="margin-right: 30px;">主管部门：{{rowInfor.manage_dept}}</div>
								<div>离校实习：{{rowInfor.leaving_school}}</div>
							</div>
							<div class="flex">
								<div style="margin-right: 30px;" class="flex align-center">985：
									<img v-if="rowInfor.university_feature && rowInfor.university_feature.indexOf('985')!=-1"
										src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
									<img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
								</div>
								<div style="margin-right: 30px;" class="flex align-center">211：
									<img v-if="rowInfor.university_feature && rowInfor.university_feature.indexOf('211')!=-1"
										src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
									<img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
								</div>
								<div style="margin-right: 30px;" class="flex align-center">一流大学：
									<img v-if="rowInfor.university_feature && rowInfor.university_feature.indexOf('一流大学')!=-1"
										src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
									<img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
								</div>
								<div style="margin-right: 30px;" class="flex align-center">一流学科：
									<img v-if="rowInfor.university_feature && rowInfor.university_feature.indexOf('一流学科')!=-1"
										src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
									<img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
								</div>
								<div style="margin-right: 30px;" class="flex align-center">研究生院：
									<img v-if="rowInfor.university_feature && rowInfor.university_feature.indexOf('研究生院')!=-1"
										src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
									<img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
								</div>
								<div style="margin-right: 30px;" class="flex align-center">有硕士：
									<img v-if="rowInfor.university_feature && rowInfor.university_feature.indexOf('有硕士')!=-1"
										src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
									<img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
								</div>
								<div class="flex align-center">有博士：
									<img v-if="rowInfor.university_feature && rowInfor.university_feature.indexOf('有博士')!=-1"
										src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
									<img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
								</div>
								<div style="margin:0 40px;position: relative;top:-20px" class="flex">
									<div class="flex align-center borders xiaoshou"
										:class="rowInfor.collect_flag==1?'border3':'border2'"
										style="margin-right: 13px; padding: 3px 8px;background-color: #FFFFFF;" @click="Collection">
										<img v-if="rowInfor.collect_flag==1" src="../assets/img/xing1.png"
											style="width:14px;height:14px;margin-right: 5px;"></img>
										<img v-if="rowInfor.collect_flag!=1" src="../assets/img/xing2.png"
											style="width:14px;height:14px;margin-right: 5px;"></img>
										收藏
									</div>
									<div class="flex align-center borders xiaoshou"
										:class="rowInfor.follow_flag==1?'border3':'border2'"
										style="padding: 3px 8px;background-color: #FFFFFF;" @click="follow">
										<img v-if="rowInfor.follow_flag==1" src="../assets/img/xin1.png"
											style="width:14px;height:14px;margin-right: 5px;"></img>
										<img v-if="rowInfor.follow_flag!=1" src="../assets/img/xin2.png"
											style="width:14px;height:14px;margin-right: 5px;"></img>
										关注
									</div>
								</div>
							</div>
						</div>
				</el-col>
			</el-row>
			</div>
		<div style="width: 100%;height:42px;color:#ffffff" class="font backbg">
			<el-row type="flex" justify="center">
				<el-col :span="22">
			<div style="margin:0 auto;height:100%;" class="flex">
				<div style="width:84px;height:100%;line-height: 42px;text-align: center;" class="xiaoshou"
					:class="indexs==index?'bgactive':''" v-for="(item,index) in list" :key="index"
					@click="clickIndex(index)">{{item.name}}</div>
			</div>
			</el-col>
			</el-row>
		</div>
		<el-row type="flex" justify="center">
			<el-col :span="22">
		<div style="margin: 20px auto;">
			<div style="text-align: left;" class="font flex align-center">
				<div @click="backIndex()" class="xiaoshou">首页</div>
				>{{rowInfor.name}}
				><div @click="backsxh()" class="xiaoshou">{{list[indexs].name}}</div>
				<div v-if="indexs==0&&sxhtype==1" class="flex align-center">
					><div>{{tableData[sxhindex].name}}</div>
				</div>
				<div v-if="indexs==2&&sxhtype==1" class="flex align-center">
					><div>{{stuinfor[sxhindex].name}}</div>
				</div>
				<div v-if="indexs==5&&sxhtype==1" class="flex align-center">
					><div>{{xzhaolist[sxhindex].name}}</div>
				</div>
			</div>
			<!-- 双选会 -->
			<div class="" v-if="indexs==0">
				<div class="" v-if="sxhtype==0">
					<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">{{list[indexs].name}}</div>
					<div style="width:100%" class="font">
						<el-table :data="tableData" height="313px" :row-style="{height:'10px'}"
							:row-class-name="tableRowClassName" @row-click="onRowClick" style="width: 100%">
							<el-table-column prop="new" label="双选会时间" header-align="center" align="center">
								<template slot-scope="scope">
									<div>{{scope.row.begin_date == scope.row.end_date ? scope.row.begin_date : `${scope.row.begin_date} - ${scope.row.end_date}`}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="meeting_type" label="双选会形式" header-align="center" align="center">
							</el-table-column>
							<el-table-column prop="name" label="双选会名称" header-align="center" align="center">
							</el-table-column>
							<el-table-column label="是否过期" header-align="center" align="center">
								<template slot-scope="scope">
									<div v-if="scope.row.invalid_flag==0">未过期</div>
									<div v-else>已过期</div>
								</template>
							</el-table-column>
						</el-table>
						<div class="font flex all-justify-end align-center"
							style="width:100%;margin: 10px 0;text-align: end;">
							<el-pagination hide-on-single-page layout="prev, pager, next,jumper" :page-size="30"
								:total="total" :current-page="page" @current-change="currentPage">
							</el-pagination>
							<!-- <div class="flex" style="margin-left: 10px;">
							<div :class="page==1?'ye1 color':'ye1'" >1</div>
							<div class="ye2" @click="pages()">Go</div>
						</div> -->
						</div>
					</div>
				</div>
				<div v-if="sxhtype==1">
					<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">{{tableData[sxhindex].name}}</div>
					<div class="font" style="text-align: end;color:#aaaaaa">发布时间：{{sxhcontent.begin_date}}
						浏览量：{{sxhcontent.view_num}}</div>
					<div class="fuwenben" v-html="sxhcontent.content"></div>
					<div class="flex justify-center">
						<el-button v-if="sxhcontent.invalid_flag == 0 && sxhcontent.sign_url" style="margin-top: 20px;background-color: #1cb278;"
							type="success" @click="baoming">报名双选会</el-button>
					</div>
				</div>
			</div>
			<!-- 学校简介 -->
			<div v-if="indexs==1">
				<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">学院简介</div>
				<div class="fuwenben" v-html="schcontent"></div>
			</div>
			<!-- 专业生源 -->
			<div v-if="indexs==2">
				<div v-if="sxhtype==0">
					<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">{{list[indexs].name}}</div>
					<div class="flex justify-center">
						<div class="font">
							<div class="xiaoshou" v-for="(item,index) in stuinfor" :key="index" @click="syClick(index)">
								<li style="margin: 3px;">{{item.name}}</li>
							</div>
						</div>
					</div>
				</div>
				<div v-if="sxhtype==1">
					<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">{{stuinfor[sxhindex].name}}</div>
					<!-- <el-table :data="sytableData"  :row-style="{height:'10px'}" :span-method="objectSpanMethod"
					border style="width: 100%">
					<el-table-column prop="name" label="院校名称">
					</el-table-column>
					<el-table-column prop="num" label="研究生总数" >
					</el-table-column>
					<el-table-column prop="zhuanye" label="研究生专业" >
					</el-table-column>
					<el-table-column prop="ynum" label="研究生人数">
					</el-table-column>
					<el-table-column prop="yname" label="研究生学院名称" >
					</el-table-column>
					<el-table-column prop="bnum" label="本科人数" >
					</el-table-column>
					<el-table-column prop="bname" label="本科学院名称">
					</el-table-column>
				</el-table> -->
					<div class="fuwenben" v-html="sytableData.content"></div>
				</div>
			</div>
			<!-- 就业办电话 -->
			<div v-if="indexs==3">
				<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">就业办电话</div>
				<el-row type="flex" justify="center">
					<div style="text-align: left;" class="fuwenben" v-html="jianjie.job_content"></div>
				</el-row>

				<div v-if="detailsss.job_mobiles_content">
					<el-row type="flex" justify="center">
						<div class="dsfsd fuwenben" v-html="detailsss.job_mobiles_content"></div>
					</el-row>
				</div>
				<!-- <div style="margin:20px 0;text-align: left;">
				<div style="font-size: 13px;margin:5px 0;font-weight: 600;">就业办领导：</div>
				<div style="color:#AAAAAA" class="font">就业办主任某某老师</div>
			</div>
			<div style="margin:20px 0;text-align: left;">
				<div style="font-size: 13px;margin:5px 0;font-weight: 600;">就业办说明：</div>
				<div style="color:#AAAAAA" class="font">中国人民大学( Renmin University of China )是中国共产党创办的第一所新型正规大学,是一所以人文社会科学为主的综合性研究型全国重点大学,直属于教育部,由教育部与北京市共建。学校的前身是1937年诞生于抗日战争烽火中的陕北公学,以及后来的华北联合大学和华北大学。1949年12月16日,中央人民政府政务院第十一次政务会议根据中共中央政治局的建议,通过了《关于成立中国人民大学的决定》。1950年10月3日,以华北大学为基础合并组建的中国人民大学隆重举行开学典礼,成为新中国创办的第一所新型正规大学。著名教育家吴玉章、成仿吾、袁宝华、黄达、李文海、纪宝成、陈雨露先后担任校长。现任党委书记为靳诺教授,校长为刘伟教</div>
			</div>
			<div style="margin:20px 0;text-align: left;">
				<div style="font-size: 13px;margin:5px 0;font-weight: 600;">地址：</div>
				<div style="color:#AAAAAA" class="font">北京中关村</div>
			</div>
			<div style="margin:20px 0;text-align: left;">
				<div style="font-size: 13px;margin:5px 0;font-weight: 600;">联系电话：</div>
				<div style="color:#AAAAAA" class="font">175555555555</div>
			</div> -->
				<div style="margin-top:20px;text-align: center;">
					<div style="font-size: 13px;font-weight: 600;">消息反馈</div>
					<textarea placeholder="请输入文字" style="border: 1px solid #cbcbcb;" v-model="feedback"></textarea>
					<div style="text-align: center;">
						<div class="borders backbg font xiaoshou" style="width:65px;padding:8px;color:#FFFFFF;margin:0px auto;"
							@click="feedbacks">立即提交</div>
					</div>
				</div>
			</div>
			<!-- 校招指南 -->
			<div v-if="indexs==5">
				<div v-if="sxhtype==0">
					<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">{{list[indexs].name}}</div>
					<div class="flex justify-center">
						<div style="font-size: 14px;">
							<div v-for="(item,index) in xzhaolist" class="flex align-center xiaoshou" :key="index"
								@click="syClick(index)">
								<li style="margin: 3px;text-align: left;">{{item.name}}</li>
								<span style="text-align: left;"> ({{item.publish_time}})</span>
							</div>
						</div>
					</div>
				</div>
				<div v-if="sxhtype==1">
					<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">{{xzhaolist[sxhindex].name}}</div>
					<div class="fuwenben" v-html="jycontent.content"></div>
				</div>
			</div>
			<!-- 校企交流群 -->
			<div v-if="indexs==6">
				<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">校企交流群</div>
				<!-- <div style="margin:20px 0;text-align: left;"> -->
				<!-- <div style="font-size: 13px;margin:5px 0;font-weight: 600;">交流群：</div>
				<div style="color:#AAAAAA" class="font">某某校企交流群：123456</div> -->
				<!-- </div> -->
				<el-row type="flex" justify="center">
					<div class="fuwenben" v-html="groupcontent.group_content"></div>
				</el-row>
				
			</div>
			<!-- 微信公众号 -->
			<div v-if="indexs==7">
				<div class="color " style="font-size: 23px;margin: 20px;text-align: center;">微信公众号</div>
				<!-- <div style="margin:20px 0;text-align: left;">
				<div style="font-size: 13px;margin:5px 0;font-weight: 600;">微信公众号：：</div>
				<div style="color:#AAAAAA" class="font">某某微信公众号</div>
			</div>
			<div style="margin:20px 0;text-align: left;">
				<div style="font-size: 13px;margin:5px 0;font-weight: 600;">公众号说明：</div>
				<div style="color:#AAAAAA" class="font">微信公众平台,简称公众号。曾命名为”官号平台”、”媒体平台”、微信公众号,最终定位为”公众平台”,无疑让我们看到一个微信对后续更大的期望。</div>
			</div> -->
			<el-row type="flex" justify="center">
				<div class="fuwenben" v-html="accountcontent.account_content"></div>
			</el-row>
				
			</div>
		</div>
		</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'uniInfor',
		props: {
			rowInfors: Object,
			required: true
		},
		components: {

		},
		data() {
			return {
				// 表格的页码
				page: 1,
				// 选中第几项
				indexs: '0',
				list: [{
					name: '双选会'
				}, {
					name: '学校简介'
				}, {
					name: '专业生源'
				}, {
					name: '就业办电话'
				}, {
					name: '就业信息网'
				}, {
					name: '校招指南'
				}, {
					name: '校企交流群'
				}, {
					name: '微信公众号'
				}, ],
				// 返回首页
				type: 0,
				// 双选会表格数据
				tableData: [],
				// 双选会index
				sxhindex: 0,
				sxhtype: 0,
				sxhcontent: {},
				// 学校简介内容
				schcontent: '',
				// 生源信息列表
				stuinfor: [],
				// 生源详细信息
				sytableData: [],
				// 就业办电话
				jianjie: '',
				//反馈消息
				feedback: '',
				// 校招指南列表
				xzhaolist: [],
				// 就业指导信息
				jycontent: '',
				//企业交流群
				groupcontent: '',
				//微信公众号
				accountcontent: '',
				total: 0, //数据总数
				detailsss: {},
				rowInfor: {}
			}
		},
		async mounted() {
			await this.undetails();
			if (this.indexs == 0 && this.sxhtype == 0) {
				this.doubleList();
			}
		},
		methods: {
			clickIndex(index) {
				this.indexs = index;
				this.sxhtype = 0;
				if (this.indexs == 0 && this.sxhtype == 0) {
					this.doubleList();
				} else if (this.indexs == 1) {
					this.schcontent = this.rowInfor.content;
				} else if (this.indexs == 2 && this.sxhtype == 0) {
					this.professional();
				} else if (this.indexs == 3) {
					this.officetele();
				} else if (this.indexs == 4) {
					if (this.rowInfor.job_url) {
						window.open(this.rowInfor.job_url)
					}
				} else if (this.indexs == 5 && this.sxhtype == 0) {
					this.guideslist();
				} else if (this.indexs == 6) {
					this.group();
				} else if (this.indexs == 7) {
					this.account();
				}
			},
			baoming() {
				// if(this.$store.state.isVip == 0) return this.$message.warning('只有会员才可以报名哦')
				// if (this.sxhcontent.sign_url) {
					window.open(this.sxhcontent.sign_url)
				// } else {
				// 	this.$message.warning('暂无')
				// }
			},
			// 返回首页
			backIndex() {
				this.$emit('types', this.type);
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				//把每一行的索引放进row
				row.index = rowIndex;
				// console.log(row,"row");
			},
			onRowClick(row, event, column) {
				if(row.url_type == 2){
					window.open(row.url)
				}else{
					this.sxhindex = row.index;
					// console.log(index,"index");
					this.sxhtype = 1;
					this.doubledetail();
				}
			},
			Collection() {
				if (this.rowInfor.collect_flag == 0) {
					this.$axios
						.post(`/api/university/collect`, {
							api_token: window.localStorage.getItem('token'),
							university_id: this.rowInfor.id
						})
						.then((res) => {
							if (res.data.code == 200) {
								this.rowInfor.collect_flag = 1
								this.rowInfor.collect_num++
							} else {
								this.$message.error(res.data.msg)
							}
						});
				} else {
					this.$axios
						.post(`/api/university/unCollect`, {
							api_token: window.localStorage.getItem('token'),
							university_id: this.rowInfor.id
						})
						.then((res) => {
							if (res.data.code == 200) {
								this.rowInfor.collect_flag = 0
								this.rowInfor.collect_num--
							} else {
								this.$message.error(res.data.msg)
							}
						});
				}
			},
			follow() {
				if (this.rowInfor.follow_flag == 0) {
					this.$axios
						.post(`/api/university/follow`, {
							api_token: window.localStorage.getItem('token'),
							university_id: this.rowInfor.id
						})
						.then((res) => {
							if (res.data.code == 200) {
								this.rowInfor.follow_flag = 1
								this.rowInfor.follow_num++
							} else {
								this.$message.error(res.data.msg)
							}
						});
				} else {
					this.$axios
						.post(`/api/university/unFollow`, {
							api_token: window.localStorage.getItem('token'),
							university_id: this.rowInfor.id
						})
						.then((res) => {
							if (res.data.code == 200) {
								this.rowInfor.follow_flag = 0
								this.rowInfor.follow_num--
							} else {
								this.$message.error(res.data.msg)
							}
						});
				}
			},
			//页码
			pages() {
				if (this.page != 1) {
					this.page = 1;
					this.doubleList();
				}
			},
			currentPage(val) {
				// console.log(val,"e");
				this.page = val;
				this.doubleList();
			},
			prevPage() {
				this.page--;
				this.doubleList();
			},
			nextPage() {
				this.page++;
				this.doubleList();
			},
			// 点击双选会返回
			backsxh() {
				this.sxhtype = 0;
			},
			// 生源信息click和校招指南click
			syClick(index) {
				this.sxhindex = index;
				if (this.indexs == 2) {
					if(this.stuinfor[index].url_type == 2){
						window.open(this.stuinfor[index].url)
					}else{
						this.sxhtype = 1;
						this.professdetail()
					}
				}
				if (this.indexs == 5) {
					// 校招指导详情
					if(this.xzhaolist[index].url_type == 2){
						window.open(this.xzhaolist[index].url)
					}else{
						this.sxhtype = 1;
						this.guidesdetaile();
					}
				}
			},
			// 表格合并
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0 || columnIndex === 1) {
					if (rowIndex % this.sytableData.length === 0) {
						return {
							rowspan: this.sytableData.length,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
			// 院校详情信息
			undetails() {
				return new Promise((resolve,reject) => {
					var token = "";
					if (window.localStorage.getItem('token') != '') {
						token = window.localStorage.getItem('token');
					} else {
						token = '';
					}
					this.$axios
						.get(`/api/university/detail?id=${this.rowInfors.id}&api_token=${token}`)
						.then((res) => {
							// console.log(res,"res");
							this.rowInfor=res.data.data;
							return resolve()
						});
				})
				
			},
			// 双选会列表
			doubleList() {
				this.$axios
					.get(`/api/meeting/getByUniversityId?university_id=${this.rowInfor.id}&page=${this.page}&page_size=30`)
					.then((res) => {
						this.tableData = res.data.data.list;
						this.total = res.data.data.total;
						this.total = this.$store.state.isvip == 1 ? res.data.data.total : 3;
						// console.log(this.tableData,"res1");
					});
			},
			//双选会详情
			doubledetail() {
				this.$axios
					.get(`/api/meeting/detail?id=${this.tableData[this.sxhindex].id}&api_token=${window.localStorage.getItem('token')}`)
					.then((res) => {
						this.sxhcontent = res.data.data;
						// console.log(this.sxhcontent,"res2");
					});
			},
			//专业生源列表
			professional() {
				this.$axios
					.get(`/api/university/students?university_id=${this.rowInfor.id}&page=${this.page}`)
					.then((res) => {
						this.stuinfor = res.data.data.list;
						// console.log(this.tableData,"res1");
					});
			},
			// 专业生源详情
			professdetail() {
				this.$axios
					.get(`/api/university/student/detail?id=${this.stuinfor[this.sxhindex].id}`)
					.then((res) => {
						this.sytableData = res.data.data;
						// console.log(this.sxhcontent,"res2");
					});
			},
			//就业办电话
			officetele() {
				this.$axios
					.post(`/api/university/job?id=${this.rowInfor.id}`)
					.then((res) => {
						this.jianjie = res.data.data;
					});
				this.$axios.get(
						`/api/university/detail?id=${this.rowInfor.id}&api_token=${window.localStorage.getItem('token')}`)
					.then(res => {
						this.detailsss = res.data.data
					})
			},
			// 反馈提交
			feedbacks() {
				this.$axios
					.get(
						`/api/university/feedback?university_id=${this.rowInfor.id}&api_token=${window.localStorage.getItem('token')}&content=${this.feedback}`
					)
					.then((res) => {
						if (res.data.code == 200) {
							alert('提交成功')
						}else{
							this.$message.error(res.data.msg)
						}
						// console.log(this.sxhcontent,"res2");
					});
			},
			//校招指南列表
			guideslist() {
				this.$axios
					.get(`/api/university/guides?university_id=${this.rowInfor.id}&page=${this.page}`)
					.then((res) => {
						this.xzhaolist = res.data.data.list;
						// console.log(this.tableData,"res1");
					});
			},
			//校招指导详情
			guidesdetaile() {
				this.$axios
					.get(`/api/university/guide/detail?id=${this.xzhaolist[this.sxhindex].id}`)
					.then((res) => {
						this.jycontent = res.data.data;
						// console.log(this.jycontent,"res2");
					});
			},
			//企业交流群 
			group() {
				this.$axios
					.get(`/api/university/group?id=${this.rowInfor.id}`)
					.then((res) => {
						this.groupcontent = res.data.data;
					});
			},
			//微信公众号
			account() {
				this.$axios
					.get(`/api/university/account?id=${this.rowInfor.id}`)
					.then((res) => {
						this.accountcontent = res.data.data;
					});
			}
		}
	}
</script>
<style lang="less">
	.bg1 {
		background-image: url(../assets/img/bg1.png);
		background-size: 100% 100%;
	}

	.border2 {
		border: 1px solid #949494;
	}

	.border3 {
		border: 1px solid #42b983 !important;
	}

	textarea {
		resize: none;
		border: 1px solid #cccccc;
		border-radius: 3px;
		width: 250px;
		height: 80px;
		margin: 20px;
		padding: 10px;
		outline: none;
	}

	.dsfsd p {
		font-size: 15px;
	}
	
	
</style>
